import { TranslationFile } from 'i18n'
import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import { IApplicationInformation } from 'interfaces/i-application-information'

export const InvolveSpouseFormLt = (data: IApplicationInformation) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Countries,
	])

	return {
		fieldSetName: '',
		formName: 'InvolveSpouseForm',
		description: t('forms:InvolveSpouseInformation'),
		collapsable: false,
		show: true,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'ssn',
				type: 'text',
				label: t('forms:Ssn'),
				value: data?.spouse?.ssn,
				visible: true,
				disabled: data?.spouse?.ssn?.length > 0,
				col: 12,
			},
			{
				required: true,
				controlName: 'firstName',
				type: 'text',
				label: t('forms:FirstName'),
				value: data?.spouse?.firstName,
				visible: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'lastName',
				type: 'text',
				label: t('forms:LastName'),
				value: data?.spouse?.lastName,
				visible: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'mobilePhoneNumber',
				type: 'tel', //change back to phoneNumber
				label: t('forms:MobilePhoneNo'),
				value: data.spouse?.cellPhone,
				visible: true,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^\\+370\\s?6[0-9]{7}$',
						message: t('ValidationMsgMobilePhone'),
					},
				],
				col: 12,
				wrapperClass: 'tel-container-wrapper lt', //Add this class for now when using type "tel"
			},
			{
				required: true,
				controlName: 'email',
				type: 'text',
				label: t('forms:Email'),
				value: data.spouse?.email,
				visible: true,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '\\S+@\\S+\\.\\S+',
						message: t('ValidationMsgEmail'),
					},
				],
				col: 12,
			},
		],
	}
}
